module.exports = __webpack_public_path__ + "images/feature/GTD-1-1f2fc65bf2151443418b718d6ad8c50f.png";